const l = {
  name: "UserPassword",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M13,7c0-3.9,3.1-7,7-7s7,3.1,7,7c0,3.9-3.1,7-7,7S13,10.9,13,7z M20,2c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5
	c2.8,0,5-2.2,5-5C25,4.2,22.8,2,20,2z"/>
<path class="st0" d="M6,30.5V28H4v2.5l-2.4-0.8L1,31.6l2.4,0.8l-1.5,2l1.6,1.2l1.5-2l1.5,2l1.6-1.2l-1.5-2L9,31.6l-0.6-1.9L6,30.5z"
	/>
<path class="st0" d="M16,30.5V28h-2v2.5l-2.4-0.8L11,31.6l2.4,0.8l-1.5,2l1.6,1.2l1.5-2l1.5,2l1.6-1.2l-1.5-2l2.4-0.8l-0.6-1.9
	L16,30.5z"/>
<path class="st0" d="M26,30.5V28h-2v2.5l-2.4-0.8L21,31.6l2.4,0.8l-1.5,2l1.6,1.2l1.5-2l1.5,2l1.6-1.2l-1.5-2l2.4-0.8l-0.6-1.9
	L26,30.5z"/>
<path class="st0" d="M36,30.5V28h-2v2.5l-2.4-0.8L31,31.6l2.4,0.8l-1.5,2l1.6,1.2l1.5-2l1.5,2l1.6-1.2l-1.5-2l2.4-0.8l-0.6-1.9
	L36,30.5z"/>
<path class="st0" d="M11,18c-2.8,0-5,2.2-5,5v2H4v-2c0-3.9,3.1-7,7-7h18c3.9,0,7,3.1,7,7v2h-2v-2c0-2.8-2.2-5-5-5H11z"/>
<path class="st0" d="M0,38v2h40v-2H0z"/>
</svg>
  `
};
export {
  l as UserPassword
};
